
const messages = {
    en: {
       maps: {
          location: { 
            name: 'Location',
            title: 'Location management',
            subtitle: 'View, search, create, edit and delete Location',
            creating: 'Creating Location',
            editing: 'Editing Location',
            deleting: 'Deleting Location',
            showing: 'Showing Location',
            menu: 'Location',
            labels: {
                address: 'Address',
                floor: 'Floor',
                apartment: 'Apartment',
                latitude: 'Latitude',
                longitude: 'Longitude',
                country: 'Country',
                province: 'Province',
                locality: 'Locality',
                postalCode: 'Postal Code'
            },
          
          }
       }
    },
    es: {
       maps: {
          location: { 
            name: 'Location',
            title: 'Administración de Location',
            subtitle: 'Ver, buscar, crear, editar, y borrar Location',
            creating: 'Creando Location',
            editing: 'Modificando Location',
            deleting: 'Eliminando Location',
            showing: 'Detalles de Location',
            menu: 'Location',
            labels: {
                address: 'Dirección',
                floor: 'Piso',
                apartment: 'Departamento',
                latitude: 'Latitud',
                longitude: 'Longitud',
                country: 'País',
                province: 'Provincia',
                locality: 'Localidad',
                postalCode: 'Codigo Postal'
            },
          
          }
       }
    },
    pt: {
       maps: {
          location: { 
            name: 'Location',
            title: 'Administração de Location',
            subtitle: 'Ver, buscar, criar, editar e usar Location',
            creating: 'Criando Location',
            editing: 'Edição Location',
            deleting: 'Apagando Location',
            showing: 'Detalhes do Location',
            menu: 'Location',
            labels: {
                address: 'Direção',
                floor: 'Andar',
                apartment: 'Apartamento',
                latitude: 'Latitude',
                longitude: 'Longitude',
                country: 'País',
                province: 'Província',
                locality: 'Localidade',
                postalCode: 'Código postal'
            },
          
          }
       }
    }
}

export default messages
    